import React from 'react';
import { PlayIcon, MoreHorizontalIcon, MapPinIcon, TagIcon } from 'lucide-react';
interface MusicItemProps {
  id: string;
  title: string;
  artist: string;
  album: string;
  cover: string;
  tags?: string[];
  location?: {
    lat: number;
    lng: number;
  };
  onPlay: () => void;
  onTagClick?: () => void;
}
export function MusicItem({
  title,
  artist,
  cover,
  tags,
  location,
  onPlay,
  onTagClick
}: MusicItemProps) {
  return <div className="flex items-center p-3 rounded-md hover:bg-zinc-800/50" data-id="element-33">
      <img src={cover} alt={`${title} cover`} className="w-12 h-12 rounded object-cover mr-3" data-id="element-34" />
      <div className="flex-1 mr-3" data-id="element-35">
        <p className="font-medium truncate" data-id="element-36">{title}</p>
        <p className="text-sm text-zinc-400 truncate" data-id="element-37">{artist}</p>
        <div className="flex items-center mt-1.5" data-id="element-38">
          {location && <div className="flex items-center text-xs text-zinc-500 mr-2" data-id="element-39">
              <MapPinIcon size={10} className="mr-0.5" data-id="element-40" />
              <span data-id="element-41">New York</span>
            </div>}
          {tags && tags.length > 0 && <div className="flex flex-wrap gap-1 max-w-[200px] overflow-hidden" data-id="element-42">
              {tags.slice(0, 1).map(tag => <span key={tag} className="text-xs px-2 py-0.5 bg-zinc-800 rounded-full text-zinc-400 whitespace-nowrap" data-id="element-43">
                  {tag}
                </span>)}
              {tags.length > 1 && <span className="text-xs text-zinc-500 whitespace-nowrap" data-id="element-44">
                  +{tags.length - 1}
                </span>}
            </div>}
        </div>
      </div>
      <div className="flex items-center" data-id="element-45">
        {onTagClick && <button onClick={onTagClick} className="w-8 h-8 flex items-center justify-center text-zinc-400 hover:text-white" data-id="element-46">
            <TagIcon size={18} data-id="element-47" />
          </button>}
        <button onClick={onPlay} className="w-8 h-8 flex items-center justify-center text-white" data-id="element-48">
          <PlayIcon size={18} data-id="element-49" />
        </button>
        <button className="w-8 h-8 flex items-center justify-center text-zinc-400" data-id="element-50">
          <MoreHorizontalIcon size={18} data-id="element-51" />
        </button>
      </div>
    </div>;
}